<template>
    <div class="_sidebar">
        <ul class="_sidebar_ul">
            <li 
            @click="changeActive(index)"
            :class="activeIndex==index?'router-link-active':''" 
            v-for="item,index in menu" :key="index">{{item}}</li>
        </ul>
    </div>
</template>

<script>
export default {
    props:['value'],
    data() {
        return {
            menu:['设备控制','设备管理'],
            activeIndex: this.value
        }
    },
    methods:{
        changeActive(index){
            if(this.value==index) return;
            this.activeIndex = index
            this.$emit('input', index)
        }
    }
}
</script>
<style lang="scss" scoped>
._sidebar {
    user-select: none;
    color: #fff;
    font-size: 1.5rem;
    font-style: oblique;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 99 !important;
    background: url('../img/bg.png');
    background-size: 100% auto;
    background-position: bottom;
    background-repeat: no-repeat;
    &_ul {
        display: flex;
        gap: 40px;
        list-style-type: none;
        margin-bottom: .7em;
        li{
            width: 9em;
            height: 2.6em;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: .7em;
            transition: all .5s;
            color: #029bcf;
            font-weight: bold;
            padding-top: .25em;
            background: url('../img/title_bottom.png'); // 替换为实际背景图片路径
            background-size: 100% 100%;
            background-repeat: no-repeat;
        }
        li:hover {
            cursor: pointer;
        }
        // 添加激活状态样式
        .router-link-active {
            transform: scale(1.05);
            background: url('../img/title_bottom_active.png'); // 替换为实际背景图片路径
            background-size: 100% 100%;
            background-repeat: no-repeat;
            color: #fff;
        }
    }
}
</style>